export default __webpack_public_path__ + "static/media/pragmatic.7b945981.svg";